import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FullViewComponent } from './full-view/full-view.component';


export interface GalleryImg {
  img: string;
}
export interface tabHeading {
  img: string;
  redirectURL: string;
  id: string;
  ariacontrols: string;
}
@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.less']
})


export class GalleryComponent implements OnInit {

  selectedMenu: tabHeading;

  tabheadingImg: tabHeading[] = [
    //   {
    //     img: '../../assets/images/gallery/years/akrti-2020.jpg',
    //     redirectURL: '#akrti-twenty-twenty',
    //     id: 'akrti-twenty-twenty-tab',
    //     ariacontrols: 'akrti-twenty-twenty',
    //   },
    //   {
    //     img: '../../assets/images/gallery/years/akrti-2019.jpg',
    //     redirectURL: '#akrti-twoninteen',
    //     id: 'akrti-twoninteen-tab',
    //     ariacontrols: 'akrti-twoninteen',
    //   },
    //   {
    //     img: '../../assets/images/gallery/years/akrti-2018.jpg',
    //     redirectURL: '#akrti-twoeighteen',
    //     id: 'akrti-twoeighteen-tab',
    //     ariacontrols: 'akrti-twoeighteen',
    //   },
    //   {
    //     img: '../../assets/images/gallery/years/akrti-2017.jpg',
    //     redirectURL: '#akrti-twoseventeen',
    //     id: 'akrti-twoseventeen-tab',
    //     ariacontrols: 'akrti-twoseventeen',
    //   },
    //   {
    //     img: '../../assets/images/gallery/years/akrti-2016.jpg',
    //     redirectURL: '#akrti-twosixteen',
    //     id: 'akrti-twosixteen-tab',
    //     ariacontrols: 'akrti-twosixteen',
    //   },
    //   {
    //     img: '../../assets/images/gallery/years/panache-13-15.jpg',
    //     redirectURL: '#thirteen-fifteen',
    //     id: 'thirteen-fifteen-tab',
    //     ariacontrols: 'thirteen-fifteen',
    //   },
    //   {
    //     img: '../../assets/images/gallery/years/panache-9to12.jpg',
    //     redirectURL: '#nine-twelve',
    //     id: 'nine-twelve-tab',
    //     ariacontrols: 'nine-twelve',
    //   }
  ]
  imagesData09_12: GalleryImg[] = [

  ];

  imagesData_17: object = [
    {
      id: 0,
      img: '../../../assets/images/gallery/customkurtadesign/emck-1.webp',
    },
    {
      id: 1,
      img: '../../../assets/images/gallery/customkurtadesign/emck-2.webp',
    },
    {
      id: 2,
      img: '../../../assets/images/gallery/customkurtadesign/emck-3.webp',
    },
    {
      id: 3,
      img: '../../../assets/images/gallery/customkurtadesign/emck-4.jpg',
    },
    {
      id: 4,
      img: '../../../assets/images/gallery/customkurtadesign/emck-5.jpg',
    },
    {
      id: 5,
      img: '../../../assets/images/gallery/customkurtadesign/emck-6.jpg',
    }
  ];
  imagesData_18: object = [
    {
      id: 0,
      img: '../../../assets/images/gallery/customkurtadesign/CMK-1.webp',
    },
    {
      id: 1,
      img: '../../../assets/images/gallery/customkurtadesign/CMK-2.webp',
    },
    {
      id: 2,
      img: '../../../assets/images/gallery/customkurtadesign/CMK-3.webp',
    },
    {
      id: 3,
      img: '../../../assets/images/gallery/customkurtadesign/CMK-4.jpg',
    },
  ];
  imagesData_19: object = [
    {
      id: 0,
      img: '../../../assets/images/gallery/Aariworkblouse/AWBD-1.bmp',
    },
    {
      id: 1,
      img: '../../../assets/images/gallery/Aariworkblouse/AWBD-2.jpg',
    },
    {
      id: 2,
      img: '../../../assets/images/gallery/Aariworkblouse/AWBD-3.jpg',
    },
    {
      id: 3,
      img: '../../../assets/images/gallery/Aariworkblouse/AWBD-4.jpg',
    },

  ];
  imagesData_20: object = [
    {
      id: 0,
      img: '../../../assets/images/gallery/Bridalblousedesign/BBd-1.jpg',
    },
    {
      id: 1,
      img: '../../../assets/images/gallery/Bridalblousedesign/BBd-2.jpg',
    },
    {
      id: 2,
      img: '../../../assets/images/gallery/Bridalblousedesign/BBd-3.jpg',
    },
    {
      id: 3,
      img: '../../../assets/images/gallery/Bridalblousedesign/BBd-4.jpg',
    },
    {
      id: 4,
      img: '../../../assets/images/gallery/Bridalblousedesign/BBd-5.jpg',
    },
    {
      id: 5,
      img: '../../../assets/images/gallery/Bridalblousedesign/BBd-6.jpg',
    },
    {
      id: 6,
      img: '../../../assets/images/gallery/Bridalblousedesign/BBD-7.jpg',
    },
    {
      id: 7,
      img: '../../../assets/images/gallery/Bridalblousedesign/BBD-8.jpg',
    },
  ];
  imagesData_21: object = [

    {
      id: 0,
      img: '../../../assets/images/gallery/trendy blouse/B-1.jpeg',
    },
    {
      id: 1,
      img: '../../../assets/images/gallery/trendy blouse/b-2.jpg',
    },
    {
      id: 2,
      img: '../../../assets/images/gallery/trendy blouse/b-3.jpg',
    },
    {
      id: 3,
      img: '../../../assets/images/gallery/trendy blouse/b-4.jpg',
    },
    {
      id: 4,
      img: '../../../assets/images/gallery/trendy blouse/b-5.jpg',
    },
    {
      id: 5,
      img: '../../../assets/images/gallery/trendy blouse/b-6.jpg',
    },
    {
      id: 6,
      img: '../../../assets/images/gallery/trendy blouse/b-2.jpg',
    },
    {
      id: 7,
      img: '../../../assets/images/gallery/trendy blouse/b-3.jpg',
    },

  ];
  constructor(public dialog: MatDialog) { }

  // openDialog(event:any): void {
  //   let imgURL = event.srcElement.src;
  //   const dialogRef = this.dialog.open(FullViewComponent, {
  //     width: '750px',
  //     data: {img: imgURL}
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     console.log('The dialog was closed');
  //   });
  // }
  index: any;
  carosuals_data: any = this.imagesData_21;
  selectTab(event) {
    if (event.index == 0) {
      this.carosuals_data = this.imagesData_21;
    } else if (event.index == 1) {
      this.carosuals_data = this.imagesData_20;
    } else if (event.index == 2) {
      this.carosuals_data = this.imagesData_19;
    } else if (event.index == 3) {
      this.carosuals_data = this.imagesData_18;
    } else if (event.index == 4) {
      this.carosuals_data = this.imagesData_17;
    }
  }
  openDialog(i: any, carousals): void {
    let imgIndex = i;
    let current_img = carousals.img;
    const dialogRef = this.dialog.open(FullViewComponent, {
      // width: '550px',
      // height: '400px',
      // overflow:'32',
      data: { imgIndex: imgIndex, carousals_data: this.carosuals_data, current_img: current_img }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(' The dialog closed');
    });
  }

  ngOnInit() {
  }

  listClick(event: any, menu: tabHeading) {
    this.selectedMenu = menu;
  }

}
